import ResortLandingPage from "@/components/ResortLandingPage";

const WanderlustExperience = () => {
  return (
    <ResortLandingPage
      developmentSlug="wanderlust-experience"
      title="Wanderlust Experience"
      subtitle="Experiencia de montanha em Campos do Jordao com foco em conforto, bem-estar e lazer em clima de serra."
      cityState="Campos do Jordao/SP"
      description="O Wanderlust Experience combina estrutura moderna, areas de relaxamento e excelente localizacao em Campos do Jordao. E uma opcao para quem busca hospedagem premium com perfil de resort na Serra da Mantiqueira."
      bannerPath="/empreendimentos/wanderlust-banner.jpg"
      galleryPaths={[
        "/empreendimentos/wanderlust-banner.jpg",
        "/empreendimentos/wanderlust-galeria-1.jpg",
        "/empreendimentos/wanderlust-galeria-2.jpg",
      ]}
      address="Rua das Acacias, 225"
      bookingPhone="(12) 3663-3584"
      whatsapp="(12) 3663-3584"
      email="reservas@wanderlustexperience.com.br"
    />
  );
};

export default WanderlustExperience;
